import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import PageLayout from '../../components/layouts/PageLayout';
import Tabs from '../../components/common/Tabs';
import UserManagementContent from './UserManagementContent';
import FacilityDetails from './FacilityDetails';
import type { Facility } from '../../types/facility.types';

interface LocationState {
  facilityId?: string;
  facilityName?: string;
  facility?: Facility; // Full Facility object from API
  activeTab?: 'users' | 'details'; // Tab to show when navigating to this page
}

const FacilityView: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const locationState = location.state as LocationState | null;
  const facilityId = locationState?.facilityId;
  const facilityName = locationState?.facilityName || 'Facility';
  const facility = locationState?.facility;
  const initialTab = locationState?.activeTab || 'details';

  const [activeTab, setActiveTab] = useState<'users' | 'details'>(initialTab);

  const tabs = [
    { id: 'details', label: 'Facility Details' },
    { id: 'users', label: 'Users' },
  ];

  return (
    <PageLayout
      title={`Facility Management | ${facilityName}`}
      onBack={() => navigate('/facilities')}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100vh - 56px)',
          width: '100%',
        }}
      >
        {/* Tabs */}
        <Tabs
          tabs={tabs}
          activeTab={activeTab}
          onTabChange={tabId => setActiveTab(tabId as 'users' | 'details')}
        />

        {/* Tab Content */}
        <div
          style={{
            flex: 1,
            overflow: 'auto',
            backgroundColor: 'var(--bg-primary)',
          }}
        >
          {activeTab === 'users' ? (
            <UserManagementContent
              facilityId={facility?.id?.toString() || facilityId}
              facilityCode={facility?.facility_code}
              facilityName={facilityName}
            />
          ) : (
            <FacilityDetails
              facilityId={facilityId}
              facilityName={facilityName}
              facility={facility}
            />
          )}
        </div>
      </div>
    </PageLayout>
  );
};

export default FacilityView;
